import { useQuery } from "@tanstack/react-query";
import { Customization } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import { fetchCustomization } from "../../../services/accounts/account";
import { accountsKeys } from "./query_keys";

export const useCustomization = (accountId: number | undefined, options?: QueryOptions<Customization>) =>
  useQuery<Customization>(accountsKeys.locales(accountId), () => fetchCustomization(accountId), {
    ...options
  });
